<template>
  <v-card-text v-if="item && item.doc">
    <v-row>
      <v-col cols="12">
        <p class="title white--text"># {{item.doc.hashtag}}</p>
      </v-col>
      <v-col cols="6">
        <h3 class="subtitle-2">Concept</h3>
        <p class="body-1 white--text" v-html="item.doc.concept"></p>
        <h3 class="subtitle-2">One liner</h3>
        <p class="body-1 white--text" v-html="item.doc.sentence"></p>
      </v-col>
      <v-col cols="6">
        <h3 class="subtitle-2">Activation ideas</h3>
        <ul>
          <li
            v-for="(tag, index) in item.doc.channels"
            :key="`channel-${index}`"
            class="body-1 white--text"
          >
            {{ tag }}
          </li>
        </ul>
        <h3 class="subtitle-2 mt-5">Earned media</h3>
        <ul>
          <li
            v-for="(tag, index) in item.doc.earned"
            :key="`earned-${index}`"
            class="body-1 white--text"
          >
            {{ tag }}
          </li>
        </ul>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");
export default {
  name: "ActivationShow",
  data() {
    return {
      item: {},
    };
  },
  props: {
    id: String,
  },
  watch: {
    id(val) {
      this.load(val);
    },
  },
  mounted() {
    this.load(this.id);
  },
  methods: {
    load(id) {
      const ref = fb.activateExCollection.doc(id);
      ref.get().then((doc) => {
        if (doc.exists) {
          this.item = doc.data();
        } else {
          alert("No such document!");
        }
      });
    },
  },
};
</script>
